// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================== */
/* OLT LAYOUT & NAVIGATION                    */
/* ========================================== */
.olt-layout-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: var(--bg-main);
}

.device-header-container {
    background-color: var(--bg-card);
    border-bottom: 1px solid var(--border-color);
    padding: 15px 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.device-info-title {
    font-size: 1.4rem;
    color: var(--accent-blue);
    font-weight: 700;
}

.device-navigation-bar {
    background-color: #1a2332;
    border-bottom: 1px solid var(--border-color);
    display: flex;
    gap: 5px;
    padding: 0 20px;
    overflow-x: auto;
}

.nav-item-link {
    color: var(--text-secondary);
    padding: 12px 18px;
    text-decoration: none;
    font-size: 0.95rem;
    font-weight: 500;
    border-bottom: 3px solid transparent;
    transition: all 0.2s;
    white-space: nowrap;
}

.nav-item-link:hover {
    color: var(--text-primary);
    background-color: rgba(255, 255, 255, 0.03);
}

.nav-item-link.active {
    color: var(--accent-blue);
    border-bottom-color: var(--accent-blue);
    background-color: rgba(56, 189, 248, 0.08);
}

.olt-content-area {
    padding: 25px;
    flex: 1 1;
}

/* Device Header Clean Layout */
.main-header {
    background-color: #1e293b;
    border-bottom: 1px solid #334155;
    padding: 15px 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #f8fafc;
    flex-wrap: wrap;
    gap: 15px;
}

.main-header .brand {
    font-size: 1.2rem;
    font-weight: 700;
    color: #38bdf8;
    display: flex;
    align-items: center;
    gap: 10px;
}

.main-header .user-info {
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 0.85rem;
    color: #94a3b8;
}

.main-header .user-info span {
    display: flex;
    align-items: center;
    gap: 6px;
}

.main-header .vendor {
    background-color: #334155;
    color: #38bdf8;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 600;
}

.header-metrics-group {
    display: flex;
    align-items: center;
    gap: 25px;
}

.device-spec-center {
    text-align: center;
}

.device-spec-center h3 {
    margin: 0;
    font-size: 1.1rem;
    color: #f8fafc;
}

.device-spec-center p {
    margin: 2px 0 0 0;
    font-size: 0.75rem;
    color: #94a3b8;
}

.gauge-item {
    text-align: center;
}

.gauge-item p {
    margin-top: 5px;
    font-size: 0.75rem;
    color: #cbd5e1;
    font-weight: 600;
}

.uptime-info {
    font-size: 0.85rem;
    color: #94a3b8;
    display: flex;
    align-items: center;
    gap: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/OLTManage/styles/layout.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C,+CAA+C;AAC/C,+CAA+C;AAC/C;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,4CAA4C;IAC5C,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,4CAA4C;IAC5C,aAAa;IACb,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,SAAO;AACX;;AAEA,+BAA+B;AAC/B;IACI,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ","sourcesContent":["/* ========================================== */\n/* OLT LAYOUT & NAVIGATION                    */\n/* ========================================== */\n.olt-layout-container {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    background-color: var(--bg-main);\n}\n\n.device-header-container {\n    background-color: var(--bg-card);\n    border-bottom: 1px solid var(--border-color);\n    padding: 15px 25px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.device-info-title {\n    font-size: 1.4rem;\n    color: var(--accent-blue);\n    font-weight: 700;\n}\n\n.device-navigation-bar {\n    background-color: #1a2332;\n    border-bottom: 1px solid var(--border-color);\n    display: flex;\n    gap: 5px;\n    padding: 0 20px;\n    overflow-x: auto;\n}\n\n.nav-item-link {\n    color: var(--text-secondary);\n    padding: 12px 18px;\n    text-decoration: none;\n    font-size: 0.95rem;\n    font-weight: 500;\n    border-bottom: 3px solid transparent;\n    transition: all 0.2s;\n    white-space: nowrap;\n}\n\n.nav-item-link:hover {\n    color: var(--text-primary);\n    background-color: rgba(255, 255, 255, 0.03);\n}\n\n.nav-item-link.active {\n    color: var(--accent-blue);\n    border-bottom-color: var(--accent-blue);\n    background-color: rgba(56, 189, 248, 0.08);\n}\n\n.olt-content-area {\n    padding: 25px;\n    flex: 1;\n}\n\n/* Device Header Clean Layout */\n.main-header {\n    background-color: #1e293b;\n    border-bottom: 1px solid #334155;\n    padding: 15px 25px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: #f8fafc;\n    flex-wrap: wrap;\n    gap: 15px;\n}\n\n.main-header .brand {\n    font-size: 1.2rem;\n    font-weight: 700;\n    color: #38bdf8;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.main-header .user-info {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    font-size: 0.85rem;\n    color: #94a3b8;\n}\n\n.main-header .user-info span {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.main-header .vendor {\n    background-color: #334155;\n    color: #38bdf8;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-weight: 600;\n}\n\n.header-metrics-group {\n    display: flex;\n    align-items: center;\n    gap: 25px;\n}\n\n.device-spec-center {\n    text-align: center;\n}\n\n.device-spec-center h3 {\n    margin: 0;\n    font-size: 1.1rem;\n    color: #f8fafc;\n}\n\n.device-spec-center p {\n    margin: 2px 0 0 0;\n    font-size: 0.75rem;\n    color: #94a3b8;\n}\n\n.gauge-item {\n    text-align: center;\n}\n\n.gauge-item p {\n    margin-top: 5px;\n    font-size: 0.75rem;\n    color: #cbd5e1;\n    font-weight: 600;\n}\n\n.uptime-info {\n    font-size: 0.85rem;\n    color: #94a3b8;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
